import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = "/api"

// Two axios instances by design:
//
//   `http`     — default. NO credentials. Used by 99% of the app — every
//                public read (/stats, /meta, /institutions, /search/suggest)
//                and the public complaint POST. Skipping `withCredentials`
//                lets the response carry `Access-Control-Allow-Origin: *`,
//                which works on every origin (canonical, preview, static
//                bundle, mobile WebView, etc.) without ingress-level CORS
//                surgery.
//
//   `httpAuth` — credentialed. Used ONLY by /auth/* and /admin/*. Cookies
//                are required for the JWT session. Callers MUST be on the
//                canonical origin or a CORS-allowlisted origin.
export const http = axios.create({ baseURL: API });
export const httpAuth = axios.create({ baseURL: API, withCredentials: true });

export async function fetchInstitutions(params) {
  const { data } = await http.get("/institutions", { params });
  return data;
}

export async function fetchInstitution(id) {
  const { data } = await http.get(`/institutions/${id}`);
  return data;
}

export async function fetchMeta() {
  const { data } = await http.get("/meta");
  return data;
}

export async function fetchStats() {
  const { data } = await http.get("/stats");
  return data;
}

export function buildExportUrl(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v && v !== "All") search.append(k, v);
  });
  const qs = search.toString();
  return `${API}/export/excel${qs ? `?${qs}` : ""}`;
}
